export const name = 'searchWixCodeSdk' as const
export const namespace = 'search' as const
